import { cx } from '@utils/cx'

const CIRCLE_RADIUS = 16
const CIRCLE_CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS // ≈ 100.53

interface ToastProgressRingProps {
  progress: number
}

/**
 * Circular progress ring that displays toast timeout progress
 */
export function ToastProgressRing({ progress }: ToastProgressRingProps) {
  const offset = CIRCLE_CIRCUMFERENCE - (CIRCLE_CIRCUMFERENCE * progress / 100)

  return (
    <svg
      className="absolute inset-0 size-full -rotate-90"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="18"
        cy="18"
        r={CIRCLE_RADIUS}
        fill="none"
        className={cx('stroke-current text-gray-400')}
        strokeWidth="2.5"
        strokeDasharray={CIRCLE_CIRCUMFERENCE}
        strokeDashoffset={offset}
        strokeLinecap="round"
      />
    </svg>
  )
}

